import {
  CHANGE_ONBOARDING,
} from './actions'

export default function(state = {
  visible: false,
  step: 0,
  question: '',
  text: '',
  button: '',
  marginLeft: '',
  marginTop: ''
}, action) {
  switch(action.type) {
    case CHANGE_ONBOARDING:
      return action.payload
    default:
      return state
  }
}
